import { useRef, useEffect, useState } from "react";
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BannerJurados } from "../components/BannerJurados";
import { TextoInicialJurados } from "../components/TextoInicialJurados";
import { Footer } from "../../../components/Landing/Footer";
import { TextoinicialNumero } from "../components/TextoinicialNumero";
import { Input, Button, Modal, Radio, message} from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useDocAdministrativosJurados } from "../../../hooks/useDocAdministrativosJurados";
import { useDocumentosAdministrativos } from "../../../hooks/useDocumentosAdministrativos";
import { DownloadFile } from "../../../utils/DownloadFile";
import { useNavigate } from "react-router-dom";
import { UseVerConvocatorias } from "../../../hooks/UseVerConvocatorias";
import getStorageUser from "../../../middlewares/GetStorageUser";
import "./documentacionAdministrativa.style.scss";
import { JuradosService } from "../../../api/Jurados/api-jurados";
import apiDocumentos from "../../../api/Documentos/api-documentos";
import { openNotification } from "../../../utils/Notifactions";


export const DocumentosAdministrativosJurado = () => {
  const renderNavigate = useNavigate();
  const {
    getConvocatoriaPersistente,
    convocatoriaPersitente: convocatoria,
  } = UseVerConvocatorias();
  const {
    continuarDocAdm,
  } = useDocAdministrativosJurados();
  const {
    eliminarArchivo,
    guardarArchivosAdministrativos,
    documentos,
    setDocumentos,
    guardarDeclaracion,
  } = useDocumentosAdministrativos();

  useEffect(() => {
    getConvocatoriaPersistente();
    getJury();
  }, []);

  const user = getStorageUser()



  const [documentosUsuario, setDocumentosUsuario] = useState<any>([]);

  useEffect(() => {
    if (documentos.length > 0) {
      let nuevosdocumentos = documentos;
      nuevosdocumentos.forEach((documento) => {
        if (documentosUsuario && documentosUsuario.length > 0 && documento.url_participante === undefined) {
          const filterDocumentoAdministrativo = documentosUsuario.filter((documentoAdministrativo) => documento.id == documentoAdministrativo.id);
          documento.url_participante = filterDocumentoAdministrativo[0] && filterDocumentoAdministrativo[0].url_participante !== "" ? filterDocumentoAdministrativo[0].url_participante : documento.url_participante;
        }
      });
      setDocumentos(nuevosdocumentos)
    }
  }, [documentosUsuario, documentos]);

  const [openResidenciaModal, setOpenResidenciaModal] = useState(false);
  const [tipoPersona, setTipoPersona] = useState<string>("");
  const [paisResidencia, setPaisResidencia] = useState<string>("");
  const [anosResidencia, setAnosResidencia] = useState<string>("");
  const [direccion, setDireccion] = useState<string>("");
  const [pais, setPais] = useState<string>("");
  const [ciudad, setCiudad] = useState<string>("");
  const [comuna, setComuna] = useState<string>("");
  const [fechaFirma, setFechaFirma] = useState<string>("");

  // Inicializar valores solo cuando cambia el tipo de persona (usar useRef para evitar re-ejecuciones)
  const prevTipoPersona = useRef<string>("");


  const juriesServices = new JuradosService();
  const fileInputRef = useRef<any>();
  const [preview, setPreview] = useState<any>();
  const [file, setFile] = useState<any>();

  useEffect(() => {
    // Solo ejecutar si el tipo de persona realmente cambió
    if (prevTipoPersona.current !== tipoPersona) {
      prevTipoPersona.current = tipoPersona;

      if (tipoPersona === "colombiano" && user) {
        // Si es colombiano, usar los datos del usuario
        setPaisResidencia("COLOMBIA");
        setDireccion(user.direccion || "");
        setPais("COLOMBIA");
        setCiudad(localStorage.getItem("ciudad"));
        setAnosResidencia("");
        setComuna(localStorage.getItem("comuna"));
      } else if (tipoPersona === "extranjero") {
        // Si es extranjero, limpiar los campos para que el usuario los ingrese
        setPaisResidencia(localStorage.getItem("pais"));
        setAnosResidencia("");
        setDireccion("");
        setPais(localStorage.getItem("pais"));
        setCiudad(localStorage.getItem("ciudad"));
        setComuna(localStorage.getItem("comuna"));
      }
    }
  }, [tipoPersona]);

  const normalizarTexto = (texto: string) =>
    texto
      .trim()
      .toUpperCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");

  const validarResidencia = (): string | null => {
    if (tipoPersona === "extranjero") {
      if (!paisResidencia || paisResidencia.trim() === "") {
        return "Debe ingresar el lugar de residencia";
      }
      if (!anosResidencia || parseInt(anosResidencia) < 2) {
        return "Debe ingresar los años de residencia (mínimo 2 años)";
      }
      return null;
    }
    if (tipoPersona === "colombiano") {
      if (!paisResidencia || paisResidencia.trim() === "") {
        setPaisResidencia("Colombia");
      }
      const ciudadNormalizada = normalizarTexto(ciudad || "");
      if (ciudadNormalizada === "MEDELLIN" && (!comuna || comuna.trim() === "")) {
        return "Debe ingresar la comuna";
      }
    }
    return null;
  };

  const guardarFirma = async (archivo: any) => {
    try {
      const data = await apiDocumentos.guardarArchivo(archivo);
      localStorage.setItem("firma", data.data);
      const response = await juriesServices.saveSignature(user.documento, data.data);
      if (response) {
        setFile(null);
        openNotification({
          titulo: "Hecho",
          descripcion: "La firma se guardó correctamente",
          placement: "bottomRight",
        });
      }
    } catch (err) {
      console.log(err);
      throw new Error(
        "An unhandled exception has ocrrurred at handleSubmit method"
      );
    }
  };

  const firmar = async () => {
    const validacionesBasicas: [boolean, string][] = [
      [!preview, "Debe actualizar la firma"],
      [!tipoPersona, "Debe seleccionar el tipo de persona"],
      [!direccion || direccion.trim() === "", "Debe ingresar la dirección"],
      [!pais || pais.trim() === "", "Debe ingresar el país"],
      [!ciudad || ciudad.trim() === "", "Debe ingresar la ciudad"],
    ];
    for (const [esInvalido, mensaje] of validacionesBasicas) {
      if (esInvalido) {
        message.error(mensaje);
        return;
      }
    }

    const errorResidencia = validarResidencia();
    if (errorResidencia) {
      message.error(errorResidencia);
      return;
    }

    // Encontrar el índice del documento "Declaración de Residencia" en el array documentos
    const indexDeclaracion = documentos.findIndex(
      (doc: any) => doc.descripcion === "Declaración de Residencia"
    );

    if (indexDeclaracion === -1) {
      message.error("No se encontró el documento de declaración");
      return;
    }

    // Obtener la fecha actual formateada
    const fechaActual = obtenerFechaFormateada();
    setFechaFirma(fechaActual);

    if (file) await guardarFirma(file);

    // Pasar las variables al método guardarDeclaracion
    guardarDeclaracion(indexDeclaracion, {
      tipoPersona,
      paisResidencia: tipoPersona === "colombiano" ? (paisResidencia || "Colombia") : paisResidencia,
      anosResidencia: anosResidencia,
      direccion: direccion || (tipoPersona === "colombiano" ? user.direccion : ""),
      pais: pais || (tipoPersona === "colombiano" ? "Colombia" : ""),
      ciudad: ciudad || (tipoPersona === "colombiano" ? user.ciudad : ""),
      comuna: comuna || (tipoPersona === "colombiano" ? user.comuna : ""),
      firma: localStorage.getItem("firma"),
      fechaFirma: fechaActual
    });

    // Cerrar el modal después de firmar
    setOpenResidenciaModal(false);
    message.success("Declaración firmada correctamente");
  }


  const obtenerFechaFormateada = () => {
    const fechaActual = new Date();
    const meses = [
      "enero", "febrero", "marzo", "abril", "mayo", "junio",
      "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
    ];
    const dia = fechaActual.getDate();
    const mes = meses[fechaActual.getMonth()];
    const anio = fechaActual.getFullYear();
    return `${dia} de ${mes} de ${anio}`;
  };

  const getJury = async () => {

    const jury = await juriesServices.getJuryByDocNumber(user.documento);
    if (jury) {
      const data = await apiDocumentos.consultarArchivo(jury[0].firma);
      if (data?.data) {
        const reader = new FileReader();
        reader.readAsDataURL(data.data);
        reader.onloadend = function () {
        }
      }
      setPreview(jury[0].firma)
    }
  };

  const selectFile = (e: any) => {
    const { type } = e.target.files[0];

    if (type !== "image/png" && type !== "image/jpeg") {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos en formato .png y .jpg",
        placement: "bottomRight",
      });
    }

    const formData = new FormData();
    formData.append("archivo", e.target.files[0]);

    setFile(formData);
    setPreview(URL.createObjectURL(e.target.files[0]));
  };

  return (
    <div>
      <Header />
      <BannerJurados BannerText="Banco de Jurados - Asociar documentación administrativa" convocatorias={convocatoria} />

      <div className="container-fluid2">
        <TextoInicialJurados
          TituloSpan="Agrega documentación administrativa."
          TitulosinSpan=""
        />
      </div>

      <div className="container-fluid2">
        <div className="col-12 p-2">
          <div className="row">
            <TextoinicialNumero
              numero="9"
              textosinspan="Agregar documentación administrativa"
              textospan="Todos los campos son obligatorios"
              color="morado"
            />
          </div>
        </div>
      </div>

      <div className="container-fluid2">
        <div className="row mt-4 mb-5">
          {documentos.map((data: any, index: number) => (
              <div className="col-12 col-md-6 col-lg-4 mt-3 mb-2" key={data.id ?? index}>
                <div className="row m-0 cards-documentos">
                  <div className="col-12 mb-3 font-family-Montserrat-Bold font-size-14px">
                    {data.tipo_documento}
                  </div>
                  <div className="col-12 font-family-Montserrat-Regular font-size-14px">
                    {!data.url_participante && data.descripcion}
                  </div>
                  <div className="col d-flex">
                    {data.url_documento ? (
                      <Button
                        className="button-yellow-ghost"
                        style={{ paddingLeft: "0" }}
                        onClick={() => {
                          DownloadFile(
                            data.url_documento
                          );
                        }}
                      >
                        DESCARGAR FORMATO
                      </Button>
                    ) : (
                      <div
                        className=""
                        style={{ color: "#ff8900", marginTop: "25px" }}
                      >
                        SIN FORMATO
                      </div>
                    )}
                  </div>
                  <div className="col justify-content-flex-end">
                    {data.descripcion == 'Declaración de Residencia' ? (
                      <Button
                        className="button-azul-radius mt-2"
                        onClick={() => setOpenResidenciaModal(true)}
                      >
                        Diligenciar en línea
                      </Button>
                    ) : <Button
                      className="button-gray-ghost pe-0 pb-0 m-0 mt-4"
                      onClick={() => {
                        const input = document.getElementById(`input-file-${data.id}`);
                        if (input) {
                          input.click();
                        }
                      }}
                    >
                      CARGAR DOCUMENTO
                    </Button>}
                    <input
                      id={`input-file-${data.id}`}
                      className="inputs-ref"
                      type="file"
                      hidden
                      onChange={async (e) => {
                        guardarArchivosAdministrativos(data, e, index);
                        e.target.value = "";
                      }}
                    />
                  </div>
                  {data.url_participante && data.url_participante !== "" ? (
                    <div className="row m-0 background-color-00904C position-absolute-card-documento">
                      <div className="col-8 text-white">{data.descripcion}</div>
                      <div className="col-4 justify-content-flex-end text-white font-size-24px">
                        <CheckCircleOutlined />
                      </div>
                      <div
                        id="tipo_doc"
                        className="col-10 mb-3 font-family-Montserrat-Bold font-size-14px font-color-FFFFFF"
                      >
                        {data.tipo_documento}
                      </div>
                      <div className="col-6 justify-content-flex-end">
                        <Button
                          className="button-blanco-ghost text-uppercase font-family-Montserrat-Regular"
                          style={{ paddingLeft: "0" }}
                          onClick={(e) => {
                            const filterDoc = documentosUsuario.filter((documentoAdmin) => documentoAdmin.id !== data.id);
                            setDocumentosUsuario(filterDoc);
                            eliminarArchivo(e, index, data.id)
                          }
                          }
                        >
                          Eliminar
                        </Button>
                      </div>
                      <div className="col-6">
                        <Button className="button-blanco-ghost font-family-Montserrat-Bold text-uppercase">
                          Cargado
                        </Button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
          ))}
        </div>
      </div>
      <div
        className="container-fluid2 bg-white"
        style={{
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          paddingBottom: "0%",
        }}
      >
        <div className="col justify-content-flex-end">
          <Button className="button-blanco-radius font-size-12px" style={{ marginRight: "16px" }} onClick={() => { return renderNavigate('/usuario/Publicaciones') }}>Atrás</Button>
          <Button
            className="button-azul-radius font-size-12px"
            onClick={() => continuarDocAdm()}
          >
            Continuar
          </Button>
        </div>
      </div>
      <Footer />
      <div>
        <Modal
          style={{ top: 20, zIndex: 3 }}
          visible={openResidenciaModal}
          footer={null}
          width={800}
          maskClosable={true}
          onCancel={() => setOpenResidenciaModal(false)}
          maskStyle={{
            zIndex: 3,
            background: "rgb(12, 164, 93)",
          }}
          className="modal-postulacion-exitosa"
        >
          <div className="document-wrapper">
            <div id="modal_custom" className="document-page">

              <h3 className="text-center">
                DECLARACIÓN JURAMENTADA DE RESIDENCIA
              </h3>

              <div style={{ marginBottom: "20px" }}>
                <Radio.Group
                  value={tipoPersona}
                  onChange={(e) => setTipoPersona(e.target.value)}
                  style={{ width: "100%" }}
                >
                  <Radio value="colombiano" style={{ display: "block", marginBottom: "10px", whiteSpace: "normal" }}>
                    Persona natural: <strong>colombiano</strong>, residente en Colombia o fuera del país
                  </Radio>
                  <Radio value="extranjero" style={{ display: "block", whiteSpace: "normal" }}>
                    Persona natural: <strong>extranjero</strong>, con residencia en Colombia durante al menos los últimos dos (2) años
                  </Radio>
                </Radio.Group>
              </div>

              <p className="text-justify">
                Señores, <br />
                <strong>Convoctoria de Fomento y Estímulos para el Arte y la Cultura</strong> <br />
                Secretaría de Cultura Ciudadana <br />
                Alcaldía de Medellín <br />
                Distrito de Ciencia, Tecnología e Innovación

              </p>
              <br />
              <p className="text-justify">
                Yo, <strong>{user.nombres} {user.apellidos}</strong>, identificado(a) con{" "}
                <strong> {user.tipo_identificacion?.split('-')[1]}</strong> número{" "}
                <strong> {user.documento}</strong>, manifiesto bajo{" "}
                gravedad de juramento que mi lugar de residencia es
                <Input
                  value={pais}
                  onChange={(e) => setPais(e.target.value)}
                  placeholder="Ingrese país"
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
                {" "} y lo ha sido durante los
                últimos{" "}
                {tipoPersona === "colombiano" ? (
                  <Input
                    type="number"
                    value={anosResidencia}
                    onChange={(e) => {
                      const val = e.target.value;
                      if (Number(val) < 0) return;
                      setAnosResidencia(val);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === '-' || e.key === 'e' || e.key === '+' || e.key === '.') {
                        e.preventDefault();
                      }
                    }}
                    placeholder="Años"
                    style={{ display: "inline-block", width: "80px", margin: "0 5px" }}
                  />
                ) : (
                  <Input
                    type="number"
                    value={anosResidencia}
                    onChange={(e) => setAnosResidencia(e.target.value)}
                    placeholder="Años"
                    min={2}
                    style={{ display: "inline-block", width: "80px", margin: "0 5px" }}
                  />
                )}{" "}
                años.
              </p>
              <br />
              <p>
                <strong>Dirección: </strong>
                <Input
                  value={direccion}
                  onChange={(e) => setDireccion(e.target.value)}
                  placeholder="Ingrese la dirección"
                  style={{ display: "inline-block", width: "300px", marginLeft: "10px" }}
                />
              </p>
              <p>
                <strong>Ciudad: </strong>
                <Input
                  value={ciudad}
                  onChange={(e) => setCiudad(e.target.value)}
                  placeholder="Ingrese ciudad"
                  style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                />
              </p>

              {ciudad === "MEDELLÍN" && (
                <div>
                  <strong>Comuna: </strong>
                  <Input
                    value={comuna}
                    onChange={(e) => setComuna(e.target.value)}
                    placeholder="Ingrese comuna"
                    style={{ display: "inline-block", width: "200px", marginLeft: "10px" }}
                  />
                </div>
              )}
              <p><strong>Correo electrónico: {user.correo}</strong> </p>
              <p><strong>Teléfono: {user.celular}</strong> </p>

              <br />

              <p className="text-right">
                En constancia, se firma en {fechaFirma || obtenerFechaFormateada()}
                <img
                  src={preview}
                  style={{
                    height: "50%",
                    width: "50%",
                    borderTop: "none",
                  }}
              alt="Firma"
              />
              </p>
            </div>
          </div>
          <div className="acciones-documento">
            {/* Columna 1 */}
            <div className="accion-firma">
              <span className="asgevl_form_lable">
                Actualizar firma:
              </span>

              <input
                ref={fileInputRef}
                type="file"
                onChange={selectFile}
              />
            </div>

            {/* Columna 2 */}
            <div className="accion-botones">
              <button onClick={firmar}>Guardar documento</button>
            </div>
          </div>

        </Modal>

      </div>
    </div>
  );
};
